let gridApi;
// Define una variable global para almacenar las instancias de las tablas
const tablas = {};

async function sessionExpired(render) {
    if (render) {
        window.location.href = `/${render}`;
        return true;
    } else {
        window.location.href = '/login';
        return true;
    }
}

function SwalToast(icon, title, timer) {
    Swal.fire({
        icon: icon,
        title: title,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: timer,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
}
function SwalLoad(icon, title, text, confirm) {
    Swal.fire({
        icon: icon,
        title: title,
        text: text,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: confirm
    });
}
function spinner(valor) {

    if (valor) {

        // Swal.fire({
        //     title: '',
        //     text: '',
        //     allowOutsideClick: false,
        //     allowEscapeKey: false,
        //     showConfirmButton: false,
        //     background: 'rgba(0, 0, 0, 0)',
        // });

        // Verificar si ya existe un spinner y evitar duplicados
        if (document.getElementById("custom-spinner")) return;

        // Crear el elemento <l-grid>
        let grid = document.createElement("l-grid");
        grid.setAttribute("size", "80");
        grid.setAttribute("speed", "1.5");
        grid.setAttribute("color", "white");
        grid.id = "custom-spinner";

        // Agregar el spinner al body o a un contenedor específico
        document.body.appendChild(grid);

    } else {
        let spinner = document.getElementById("custom-spinner");
        if (spinner) {
            spinner.remove();
        }
        // Swal.close();
    }
}

// Tabla AG-Grid
function iniciarTabla(data, columnDefs, idTable, autoGroupColumnDef = null) {

    const AG_GRID_LOCALE_ES = {
        // Number Filter & Text Filter
        filterOoo: 'Filtro...',
        equals: 'Igual',
        notEqual: 'No igual',
        blank: 'En blanco',
        notBlank: 'No en blanco',

        // Text Filter
        contains: 'Contiene',
        notContains: 'No contiene',
        startsWith: 'Empieza con',
        endsWith: 'Termina con',

        // Date Filter
        dateFormatOoo: 'yyyy-mm-dd',
        before: 'Antes',
        after: 'Después',
        inRange: 'Entre',

        // Filter Conditions
        andCondition: 'AND',
        orCondition: 'OR',

        // Filter Buttons
        applyFilter: 'Apply',
        resetFilter: 'Reset',
        clearFilter: 'Clear',
        cancelFilter: 'Cancel',

        // Menu
        totalRows: 'Total Rows',
        totalAndFilteredRows: 'Rows',
        more: 'More',
        to: 'a',
        of: 'de ',
        page: 'Página',
        pageLastRowUnknown: '?',
        nextPage: 'Next Page',
        lastPage: 'Last Page',
        firstPage: 'First Page',
        previousPage: 'Previous Page',
        pageSizeSelectorLabel: 'Tamaño de Páginas:',
        footerTotal: 'Total',
    }

    const minRows = 6; // Número mínimo de filas que se deben mostrar

    if (!data || data.length < minRows) {
        const emptyRowsNeeded = minRows - (data ? data.length : 0);
        const emptyRows = Array.from({ length: emptyRowsNeeded }, () => ({}));
        data = data ? [...data, ...emptyRows] : emptyRows;
    }

    gridOptions = {
        defaultColDef: {
            resizable: true,
            filter: 'agTextColumnFilter',
            cellDataType: false,
        },
        // rowNumbers: true,
        // rowHeight: 50,
        theme: agGrid.themeBalham,
        // theme: agGrid.themeQuartz,
        columnDefs: columnDefs,
        rowData: data,
        pagination: true,
        onGridReady: function (params) {
            // Registra el evento cellClicked
            params.api.addEventListener('cellClicked', function (event) {
                const api = params.api;
                const rowIndex = event.rowIndex;
                const rowCount = api.getDisplayedRowCount(); // Obtiene el número de filas visibles

                if (rowIndex === rowCount - 1) {

                    const lastRowNode = api.getDisplayedRowAtIndex(rowCount - 1); // Obtiene la última fila visible
                    const lastRowData = lastRowNode && lastRowNode.data;

                    // Verifica si la última fila está vacía
                    if (lastRowData && Object.values(lastRowData).every(val => val === null || val === '')) {
                        // Agrega una nueva fila
                        const newRowData = {}; // Aquí puedes definir los valores por defecto de la nueva fila
                        api.applyTransaction({ add: [newRowData] }); // Agrega la nueva fila a la grilla
                    }
                }
            });

        },
        overlayLoadingTemplate: '<div aria-live="polite" aria-atomic="true" style="position:absolute;top:0;left:0;right:0; bottom:0; background: url(	https://ag-grid.com/images/ag-grid-loading-spinner.svg) center no-repeat" aria-label="loading"></div>',
        localeText: AG_GRID_LOCALE_ES,
    };

    let gridDiv = document.querySelector(idTable);
    gridApi = agGrid.createGrid(gridDiv, gridOptions);

    tablas[idTable] = gridApi;
}

function filtrarTabla(idTable, value) {
    const gridApi = tablas[idTable];
    if (gridApi) {
        gridApi.setGridOption('quickFilterText', value);
    }
}
// Formularios Altas
function limpiarForm(idform) {

    if ($(idform)[0]) {
        $(idform)[0].reset();
        // eliminar clases de error si es que hay
        $(`${idform} .campoRequerido, ${idform} .errorInput`).removeClass('campoRequerido errorInput');

        // Limpia los select y deja el primer valor vacío
        $(idform).find('select').each(function () {
            let firstOption = $(this).find('option:first');

            // Restablecer su valor y texto a una cadena vacía
            firstOption.val('');
            firstOption.text('');
        });

        // Restablecer los componentes personalizados (como <listado-srch>)
        $(idform).find('listado-srch').each(function () {
            // Restablecer manualmente el valor de los elementos personalizados
            this.value = '';  // O el valor que desees
            this.innerHTML = '';  // Si necesitas limpiar el contenido visible
        });

        // Limpia los textarea
        $(`${idform} textarea`).val('');
    }
}
function resetearTabla(idTable, buscador) {
    if (tablas[idTable]) {
        // Destruir la tabla (si es necesario)
        tablas[idTable].destroy();
        $(buscador).val('');

        // Eliminar la entrada de la tabla cerrada
        delete tablas[idTable];

        // Obtener el primer grid en tablas (si existe)
        const keys = Object.keys(tablas);
        if (keys.length > 0) {
            gridApi = tablas[keys[0]]; // Asignar la referencia del primer grid
        } else {
            gridApi = null; // No hay más tablas, asignar a null
        }
    }
}
async function cerrarVentana(idVentana, idform) {
    $(idVentana).hide();
    // Restablecer cada formulario
    idform.forEach(function (formulario) {
        $(formulario).trigger("reset");
        // $(`${idform}`).find('.errorInput, .campoRequerido').removeClass('errorInput campoRequerido');
        $(formulario).find('.errorInput, .campoRequerido').removeClass('errorInput campoRequerido');

        // Restablecer el valor y el texto del primer option de cada select
        $(formulario).find('select').each(function () {
            // Obtener el primer option
            var firstOption = $(this).find('option:first');

            // Restablecer su valor y texto a una cadena vacía
            firstOption.val('');
            firstOption.text('');
        });

        // Restablecer los componentes personalizados (como <listado-srch>)
        $(formulario).find('listado-srch').each(function () {
            // Restablecer manualmente el valor de los elementos personalizados
            this.value = '';  // O el valor que desees
            this.innerHTML = '';  // Si necesitas limpiar el contenido visible
        });
    });
}

// id del div padre a dejar Vacio 
function resetLista(id) {
    $(id).empty();
}
function validateInputs(form) {
    let isValid = true;

    // Itera sobre todos los inputs dentro del formulario
    form.find('label').each(function () {
        // Verifica si el input tiene la clase 'labelImportant'
        if ($(this).hasClass('labelImportant')) {
            const inputField = $(this).parent().find('input, select, listado-srch');

            // Si el input es vacio agrega una clase
            if (inputField.val() === '' || inputField.val() === null) {
                inputField.addClass('campoRequerido');
                $(this).closest('.form-group').addClass('errorInput');
                $(this).focus();
                isValid = false;
            } else {
                inputField.removeClass('campoRequerido');
                $(this).closest('.form-group').removeClass('errorInput');
            }
        }
    });

    return isValid;
}
// Trae la informacion de la tabla Actulmente Activa
function getDataFromGrid() {
    let allData = [];
    gridApi.forEachNode(node => allData.push(node.data));
    return allData;
}
// toma como parametro el id del campo para seleccionar todo el valor
function seleccionTxt(...idCampos) {
    idCampos.forEach(id => {
        $(document).on('focus', `#${id}`, function () {
            $(`#${id}`).select();
        });
    });
}
function sinComa(valor) {
    return valor.replace(/[\$,]/g, '');
}
function conComa(valor) {
    return valor.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function verificarArray(data) {
    return Array.isArray(data) ? data : [data];
}

// Función para formatear la cantidad como moneda
function aplicarMascaraCantidad(...inputSelector) {
    inputSelector.forEach(id => {
        $(`#${id}`).inputmask({
            alias: 'currency', // Puedes elegir entre diferentes alias (currency, decimal, integer, etc.)
            prefix: '', // Prefijo opcional
            suffix: '', // Sufijo opcional
            allowMinus: true, // Permitir números negativos (true/false)
            thousandsSeparator: ',', // Separador de miles
            decimalSeparator: '.', // Separador decimal
            digits: 2,
            max: 99999999.99 // L 8
        });
    });
}
function formatCurrency(value) {
    if (isNaN(value)) return '';
    return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function formatPeriodo(value) {
    if (!value) return;

    return value.replace(/[^0-9]/g, "")  // Elimina caracteres no numéricos
        .slice(0, 6)             // Limita a 6 dígitos (YYYYMM)
        .replace(/^(\d{4})(\d{0,2})/, "$1-$2"); // Inserta el guion
}
function aplicarMascaraNM(...inputSelector) {
    inputSelector.forEach(id => {
        $(`#${id}`).inputmask({
            alias: 'numeric', // Usamos el alias 'numeric' para aceptar solo números
            prefix: '', // Prefijo opcional
            suffix: ' NM', // Sufijo con "Km"
            allowMinus: false, // No permitimos números negativos
            autoUnmask: true, // Desenmascaramos automáticamente al obtener el valor
            greedy: false, // No permitimos caracteres adicionales
            groupSeparator: ',', // Separador de miles
            placeholder: '0', // Valor de relleno
            rightAlign: false // Alineación a la izquierda
        });
    });
}
function aplicarMascaraKm(...inputSelector) {
    inputSelector.forEach(id => {
        $(`#${id}`).inputmask({
            alias: 'numeric', // Usamos el alias 'numeric' para aceptar solo números
            prefix: '', // Prefijo opcional
            suffix: ' Km', // Sufijo con "Km"
            allowMinus: false, // No permitimos números negativos
            autoUnmask: true, // Desenmascaramos automáticamente al obtener el valor
            greedy: false, // No permitimos caracteres adicionales
            groupSeparator: ',', // Separador de miles
            placeholder: '0', // Valor de relleno
            rightAlign: false // Alineación a la izquierda
        });
    });
}
function aplicarMascaraTiempo(...inputSelector) {
    inputSelector.forEach(id => {
        $(`#${id}`).inputmask({
            // alias: 'datetime', // Usamos el alias de datetime para fechas y horas
            // prefix: '', // Prefijo opcional
            // allowMinus: false, // No permitimos números negativos
            // autoUnmask: true, // Desenmascara automáticamente al obtener el valor
            // greedy: false, // No permitimos caracteres adicionales
            // separator: ':', // Separador de horas y minutos
            // placeholder: 'HH:MM', // Placeholder que muestra el formato esperado
            // hourFormat: '24', // Formato de 24 horas
            // mask: '99:99', // Formato HH:MM
            alias: 'datetime', // Usamos el alias de datetime para fechas y horas
            inputFormat: 'HH:MM', // Formato de entrada esperado
            placeholder: 'HH:MM', // Placeholder que muestra el formato esperado
            hourFormat: '24', // Formato de 24 horas
            clearIncomplete: true, // Limpia el input si no está completo
            autoUnmask: true, // Desenmascara automáticamente al obtener el valor
            oncomplete: function () { // Función a ejecutar cuando se completa el input
                validarHora(this);
            }

        });
    });
}
function aplicarMascaraTelefono(...inputSelector) {
    inputSelector.forEach(id => {
        $(`#${id}`).inputmask({
            mask: "+52 (99) 9999 9999", // Máscara para el número telefónico
            placeholder: "", // Placeholder opcional
            showMaskOnHover: false, // Mostrar la máscara al pasar el mouse (true/false)
            showMaskOnFocus: false, // Mostrar la máscara al enfocar el input (true/false)
            definitions: {
                '9': {
                    validator: "[0-9]", // Permitir solo dígitos
                    cardinality: 1
                }
            }
        });
    });
}
function aplicarMascaraPeriodo(id) {
    const input = document.getElementById(id);

    if (!input) return;

    function formatYearMonth(value) {
        return value.replace(/[^0-9]/g, "")  // Elimina caracteres no numéricos
            .slice(0, 6)             // Limita a 6 dígitos (YYYYMM)
            .replace(/^(\d{4})(\d{0,2})/, "$1-$2"); // Inserta el guion
    }

    input.addEventListener("input", function () {
        this.value = formatYearMonth(this.value);
    });

}
function quitarGuionFecha(id) {
    return id.replace(/[^0-9]/g, '').slice(0, 6);
}
function formatearMillas(millas) {
    return `${Number(millas).toLocaleString('en-US')} NM`;
}

// ListKey
async function createDataTable(datos, columns, width, height, title) {

    return new Promise(function (resolve, reject) {
        try {
            // let listaPadre = '#padre';

            // let listaSearchOptions = document.querySelectorAll(`${listaPadre} option`);
            // listaSearchOptions.forEach(function (option) {
            //     option.textContent = '';
            //     option.value = '';
            // });

            // Crear contenedor
            let container = document.createElement("div");
            container.className = 'contenedorKey';

            // Crear Titulo TablaKey
            let titleContainer = document.createElement("div");
            titleContainer.className = 'flex-titulo';
            titleContainer.style.width = `${width}px`;

            let titleH3 = document.createElement('H3');
            titleH3.innerHTML = title;

            let icon = document.createElement('I');
            icon.className = 'fa-solid fa-xmark cerrar-tablakey';

            // Crear tabla
            var tabla = document.createElement('table');
            tabla.id = 'tableKey';
            // tabla.className = "stripe row-border order-column nowrap";
            tabla.className = "display";
            tabla.style.width = "100%";

            // Crear encabezado
            var encabezado = document.createElement('thead');
            var encabezadoFila = document.createElement('tr');

            // Obtener las claves de la primera fila para crear las columnas
            var keys = Object.keys(datos[0]);

            // Crear las columnas del encabezado
            // keys.forEach(function (key) {
            columns.forEach(function (key) {
                var th = document.createElement('th');
                th.textContent = key;
                encabezadoFila.appendChild(th);
            });

            encabezado.appendChild(encabezadoFila);
            tabla.appendChild(encabezado);

            // Crear cuerpo de la tabla
            var cuerpo = document.createElement('tbody');

            // Iterar sobre los datos para crear las filas
            datos.forEach(function (filaData) {
                var fila = document.createElement('tr');

                // Iterar sobre las propiedades de cada objeto para crear las celdas
                // keys.forEach(function (key) {
                columns.forEach(function (key) {
                    var dato = filaData[key];
                    var celda = document.createElement('td');
                    celda.textContent = dato;
                    fila.appendChild(celda);
                });

                cuerpo.appendChild(fila);
            });

            tabla.appendChild(cuerpo);

            var divTabla = document.getElementById('listKey');
            container.appendChild(titleContainer);
            titleContainer.appendChild(titleH3);
            titleContainer.appendChild(icon);
            container.appendChild(tabla);
            divTabla.appendChild(container);

            $('#tableKey').DataTable({
                fixedColumns: true,
                keys: true,
                paging: true,
                scrollCollapse: true,
                scrollY: `${height}px`, // Puedes ajustar esta altura según tus necesidades
                language: {
                    "search": "Buscar:",
                    "info": "Mostrando _END_ de _TOTAL_ Registros",
                    "infoEmpty": 'No Hay Registros',
                    "zeroRecords": 'No Se Encontraron Registros',
                    "infoFiltered": '(Filtrado de _MAX_ Registros Totales)',
                    "lengthMenu": "_MENU_ Entradas por página",
                }
            });

            var tableKeyWrapper = document.getElementById("tableKey_wrapper");
            tableKeyWrapper.style.width = `${width}px`;

            $('.cerrar-tablakey').on('click', function () {
                resetLista('#listKey');
            });

            // devuelve fila
            $('#tableKey').on('dblclick', 'tbody td', function () {
                // $(document).on('dblclick', '#tableKey tbody td', function () {
                // Obtener la fila a la que pertenece la celda
                var fila = $(this).closest('tr');

                // Obtener los datos de la fila
                var datosFila = fila.children('td').map(function () {
                    return $(this).text();
                }).get();

                // console.log(datosFila);

                // Cerrar la tabla
                resetLista('#listKey');

                resolve(datosFila);
            });

            // devuelve fila
            document.addEventListener('keydown', function (event) {

                if (event.key === 'Enter') {
                    const table = document.querySelector('#tableKey');
                    // Verifica si el evento proviene de la tabla #tableKey
                    if (table) {

                        // Encuentra la fila que contiene el elemento de destino del evento
                        const cellWithFocus = table.querySelector('td.focus');
                        if (cellWithFocus) {
                            // Encuentra la fila que contiene la celda con la clase 'focus'
                            const row = cellWithFocus.closest('tr');
                            if (row) {

                                // Se encontró la fila, ahora podemos trabajar con ella
                                // Obtén todas las celdas de la fila
                                const cells = row.querySelectorAll('td');

                                // Crea un array para almacenar los valores de las celdas
                                const cellValues = [];

                                // Itera sobre las celdas y obtén los valores de texto de cada una
                                cells.forEach(function (cell) {
                                    cellValues.push(cell.textContent.trim());
                                });

                                console.log(cellValues);
                                resetLista('#listKey');

                                // Muestra los valores de las celdas en la consola o haz lo que necesites con ellos
                                // console.log('Valores de la fila:', cellValues);

                                resolve(cellValues);
                            }
                        }
                    }
                }
            });

        } catch (error) {
            console.error('Error al obtener y mostrar los datos:', error);
            reject('error');
        }
    });
}
// El listado Anterior, no funcionaba en Ipad
async function mostrarListaSearchold(datos, listaSearch, valorOpt, textOpt, add) {
    return new Promise((resolve, reject) => {
        try {

            // if (datos.length < 1) reject('No hay data');

            let listaPadre = $(listaSearch);
            let inputSearch = listaPadre.find('input');
            let selectPadre = listaPadre.parent().find('select');
            let currentIndex = -1; // Variable para almacenar el índice de la opción actualmente seleccionada

            if (!inputSearch.length === 0 || !selectPadre.length === 0) {
                reject('No se encontro HTML');
            }

            filtrarDatos();

            $(inputSearch).on('input blur', function (event) {
                if (event.type === "input") {
                    filtrarDatos();
                } else if (event.type === "blur") {
                    limpiarLista();
                }
            });

            $(inputSearch).on('keydown', function (event) {

                const listaSearchOptions = listaPadre.find('option');
                // let listaSearchOptions = document.querySelectorAll(`${listaSearch} option`);

                const totalOptions = listaSearchOptions.length;

                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    currentIndex = (currentIndex + 1) % totalOptions;
                    actualizarSeleccion();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    currentIndex = currentIndex === -1 || currentIndex === 0 ? totalOptions - 1 : (currentIndex - 1 + totalOptions) % totalOptions;
                    actualizarSeleccion();
                } else if (event.key === 'Enter' && currentIndex !== -1) {
                    event.preventDefault();
                    let option = listaSearchOptions.eq(currentIndex);
                    // Limpiar todas las opciones del select
                    selectPadre.empty();
                    if (option.val() === 'nuevo') {
                        resolve('nuevo');
                    } else {
                        // Clonar la opción seleccionada y agregarla al select
                        let selectedOption = option.clone();
                        selectPadre.append(selectedOption);
                        // Obtener el valor de la opción seleccionada
                        let selectedValue = option.val();
                        // Encontrar el objeto correspondiente a la opción seleccionada
                        let objetoSeleccionado = datos.find(objeto => objeto[valorOpt] === parseInt(selectedValue));
                        // Resolver la promesa con el objeto seleccionado
                        currentIndex = -1;
                        $(listaSearch).hide();
                        resolve(objetoSeleccionado);
                    }

                }
            });

            function actualizarSeleccion() {
                const listaSearchOptions = listaPadre.find('option');
                listaSearchOptions.removeClass('listOption');
                if (currentIndex !== -1) {
                    listaSearchOptions.eq(currentIndex).addClass('listOption');
                }
            }

            function filtrarDatos() {

                let inputText = $(inputSearch).val().trim().toLowerCase();
                let filteredNames = datos.filter(function (item) {
                    return (item[textOpt] ? item[textOpt].toLowerCase() : '').includes(inputText);
                }).slice(0, 5);

                let listaSearchOptions = document.querySelectorAll(`${listaSearch} option`);
                // Iterar sobre cada opción
                listaSearchOptions.forEach(function (option) {
                    // Eliminar cada opción
                    option.remove();
                });

                if (add) {
                    let valNuevo = { [valorOpt]: 'nuevo', [textOpt]: 'Nuevo' };
                    filteredNames.unshift(valNuevo);
                }

                if (filteredNames.length > 0) {
                    filteredNames.forEach(function (item) {

                        let option = $('<option>').val(item[valorOpt]).text(item[textOpt]);
                        listaPadre.append(option);

                        option.on('mousedown', function (event) {
                            event.preventDefault(); // Prevenir el comportamiento predeterminado
                            // eliminar option anteriores
                            selectPadre.empty();
                            if (option.val() === 'nuevo') {
                                selectPadre.append('');
                                limpiarLista();
                                resolve('nuevo');
                            } else {
                                // agregar el option seleccionado
                                selectPadre.append(option);
                                limpiarLista();
                                resolve(item);
                            }
                        });
                    });
                } else {
                    listaPadre.append('<option disabled>No se encontraron resultados</option>');
                }
            }

            function limpiarLista() {
                // Ocultar y Limpiar busqueda
                let listaSearchOptions = document.querySelectorAll(`${listaSearch} option`);
                listaSearchOptions.forEach(function (option) {
                    option.remove();
                });
                $(inputSearch).val('');
                $(listaSearch).hide();

                currentIndex = -1;
            }


        } catch (error) {
            console.error('Error al obtener y mostrar los datos:', error);
            reject('error')
        }
    });
}
// Este es el valor directamente
// camposExtra: campos adicionales por los que también se puede buscar (p.ej. ['codigo_icao']), sin afectar el texto mostrado
async function mostrarListaSearch(datos, listaSearch, valorOpt, textOpt, add, camposExtra = []) {
    return new Promise((resolve, reject) => {
        try {

            if (datos.length < 1) reject('No hay data');

            const listaPadre = $(listaSearch);
            const inputSearch = listaPadre.find('input');
            const selectPadre = listaPadre.parent().find('select');
            const objSelect = listaPadre.parent().find('listado-srch');

            if (listaPadre.find('ul').length < 1) {
                reject('No se encontró un elemento <ul>');
                return
            }

            const listadoSearch = listaPadre.find('ul');

            let currentIndex = -1; // Índice de la opción seleccionada

            if (!inputSearch.length === 0 || !selectPadre.length === 0) {
                reject('No se encontro HTML');
            }

            filtrarDatos();

            inputSearch.on('input blur', (event) => {
                if (event.type === "input") {
                    filtrarDatos();
                } else {
                    limpiarLista();
                }
            });

            inputSearch.on('keydown', (event) => {
                const listaSearchOptions = listaPadre.find('listado-srch');
                const totalOptions = listaSearchOptions.length;

                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    currentIndex = (currentIndex + 1) % totalOptions;
                    actualizarSeleccion();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    currentIndex = currentIndex === -1 || currentIndex === 0 ? totalOptions - 1 : (currentIndex - 1 + totalOptions) % totalOptions;
                    actualizarSeleccion();
                } else if (event.key === 'Enter' && currentIndex !== -1) {
                    event.preventDefault();
                    let option = listaSearchOptions.eq(currentIndex);

                    objSelect.empty(); // Limpiar el select

                    if (option.val() === 'nuevo') {
                        resolve('nuevo');
                    } else {
                        const selectedValue = option.val();
                        let objetoSeleccionado = datos.find(objeto => objeto[valorOpt] === parseInt(selectedValue));
                        currentIndex = -1;

                        objSelect.attr('value', option.val());
                        objSelect.text(option.text());

                        $(listaSearch).hide();
                        resolve(objetoSeleccionado);
                    }

                }
            });

            function actualizarSeleccion() {
                const listaSearchOptions = listaPadre.find('listado-srch');
                listaSearchOptions.removeClass('listOption');
                if (currentIndex !== -1) listaSearchOptions.eq(currentIndex).addClass('listOption');
            }

            function filtrarDatos() {

                let inputText = $(inputSearch).val().trim().toLowerCase();
                const camposBusqueda = [textOpt, ...camposExtra];
                const filteredNames = datos.filter(item =>
                    camposBusqueda.some(campo => (item[campo] ?? '').toString().toLowerCase().includes(inputText))
                ).slice(0, 5);

                let listaSearchLI = document.querySelectorAll(`${listaSearch} ul`);
                listaSearchLI[0].innerHTML = '';

                if (add) {
                    filteredNames.unshift({ [valorOpt]: 'nuevo', [textOpt]: 'Nuevo' });
                }

                if (filteredNames.length > 0) {
                    filteredNames.forEach(function (item) {

                        const lista = $('<listado-srch>')
                            .val(item[valorOpt])
                            .text(item[textOpt])
                            .on('mousedown', (event) => {
                                event.preventDefault();
                                objSelect.empty();

                                if (lista.val() === 'nuevo') {
                                    selectPadre.append('');
                                    limpiarLista();
                                    resolve('nuevo');
                                } else {
                                    objSelect.attr('value', item[valorOpt]);
                                    objSelect.text(item[textOpt]);
                                    limpiarLista();
                                    resolve(item);
                                }
                            });

                        listadoSearch.append(lista);
                    });


                }
                else {
                    listaSearchLI[0].append('No se encontraron resultados');
                }
            }

            function limpiarLista() {
                let listaSearchLI = document.querySelectorAll(`${listaSearch} ul`);
                listaSearchLI[0].innerHTML = '';
                $(inputSearch).val('');
                $(listaSearch).hide();
                currentIndex = -1;
            }


        } catch (error) {
            console.error('Error al obtener y mostrar los datos:', error);
            reject('error')
        }
    });
}

// acepta iPad
async function mostrarListaGrid(cellElement, datos, contLista, contScroll) {

    return new Promise((resolve, reject) => {
        try {

            const contFiltro = document.querySelector(contLista);
            if (!contFiltro) return;
            contFiltro.classList.add('filtro_grid');

            const inputSearch = Object.assign(document.createElement('input'), {
                type: 'text',
                id: 'filtro_search',
                placeholder: 'Buscar...',
                autocomplete: 'off',
            });

            // Crear el ícono de búsqueda
            const searchIcon = document.createElement('i');
            searchIcon.classList.add('fa-solid', 'fa-magnifying-glass');

            // Crear el contenedor para la lista de opciones
            const filtroList = document.createElement('div');
            filtroList.id = 'filtro_list';
            filtroList.classList.add('container', 'Search');

            // Agregar el input y el ícono al primer div dentro del contenedor
            const inputDiv = document.createElement('div');
            inputDiv.append(inputSearch, searchIcon);

            // Agregar los elementos al contenedor principal
            contFiltro.append(inputDiv, filtroList);

            const updatePopupPosition = () => {
                const contenedorScroll = document.querySelector(contScroll);
                if (!contenedorScroll) return; // Salir si no se encuentra el contenedor

                // Calcular la posición de la celda en relación con el contenedor con scroll
                const cellRect = cellElement.getBoundingClientRect();
                const contenedorRect = contenedorScroll.getBoundingClientRect();
                const cellTopInContainer = cellRect.top - contenedorRect.top + contenedorScroll.scrollTop;

                // Altura del div que se mostrará encima de la celda (ajustar según tu contenido)
                const popupDivHeight = 100; // Altura del div en píxeles

                // Calcular la posición superior del div encima de la celda en el contenedor
                const popupTop = cellTopInContainer + cellElement.clientHeight;

                // Actualizar la posición del contenedor filtro
                Object.assign(contFiltro.style, {
                    left: `${cellRect.left}px`,
                    top: `${popupTop}px`,
                });

                // if (contFiltro) {
                //     contFiltro.style.left = `${cellRect.left}px`; // Posición izquierda de la celda
                //     contFiltro.style.top = `${popupTop}px`; // Posición encima del popupDiv
                //     // contFiltro.style.width = `${cellRect.width}px`; // Ancho igual al ancho de la celda
                // }
            };

            // const existeLista = document.querySelector('#filtro_list ul listado-srch');

            $(contFiltro).show();
            // Crear el div para mostrar encima de la celda clicada
            const listUL = document.createElement('ul');
            if (datos.length > 0) {
                datos.forEach((item) => {
                    const lista = $('<listado-srch>').val(item.id).text(item.nombre);
                    listUL.appendChild(lista[0]); // Convertir el elemento jQuery a un DOM node y añadirlo al listUL
                });
            }
            filtroList.appendChild(listUL);

            // Insertar el div en el contenedor con scroll
            const contenedorScroll = document.querySelector(contScroll);
            if (contenedorScroll) {
                contenedorScroll.appendChild(contFiltro);
                // Actualizar la posición inicial del div
                updatePopupPosition();
            }

            // Agregar un listener para cerrar el div al hacer clic fuera de él
            const closePopup = function (e) {
                if (!contFiltro.contains(e.target) && !listUL.contains(e.target) && e.target !== cellElement) {
                    // Cerrar el filtro y limpiar el listUL
                    $(contFiltro).hide();
                    $(listUL).empty();

                    limpiarLista();

                    // Eliminar el listener de clic para cerrar el popup
                    document.removeEventListener('click', closePopup);
                    contenedorScroll.removeEventListener('scroll', updatePopupPosition); // Detener el seguimiento del scroll del contenedor
                }
            };

            // Agregar un listener para cerrar el div al hacer clic fuera de él
            document.addEventListener('click', closePopup);

            inputSearch.focus();
            let currentIndex = -1; // Variable para almacenar el índice de la opción actualmente seleccionada

            // Navegar con Flechas
            $(inputSearch).keydown(async event => {
                const listaSearchOptions = $(listUL).find('listado-srch');
                const totalOptions = listaSearchOptions.length;

                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    currentIndex = (currentIndex + 1) % totalOptions;
                    await actualizarSeleccion();
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    currentIndex = currentIndex === -1 || currentIndex === 0 ? totalOptions - 1 : (currentIndex - 1 + totalOptions) % totalOptions;
                    actualizarSeleccion();
                } else if (event.key === 'Enter' && currentIndex !== -1) {
                    event.preventDefault();
                    let option = listaSearchOptions.eq(currentIndex);
                    let selectedOption = option.clone();
                    listUL.append(selectedOption);
                    let selectedValue = option.val();
                    const resultado = datos.find(item => item.id == selectedValue);
                    if (resultado) resolve(resultado);
                    limpiarLista();
                }
            });

            async function actualizarSeleccion() {
                const listaSearch = $(listUL).find('listado-srch');

                listaSearch.removeClass('listOption');
                if (currentIndex !== -1) {
                    listaSearch.eq(currentIndex).addClass('listOption');
                }
            }

            // Buscador 
            filtrarDatos();

            $(inputSearch).on('input blur', function (event) {
                if (event.type === "input") {
                    filtrarDatos();
                } else if (event.type === "blur") {
                    limpiarLista();
                }
            });


            function filtrarDatos() {
                let inputText = $(inputSearch).val().trim().toLowerCase();
                let filteredDatos = datos.filter(function (item) {
                    let nombre = (item['nombre'] || '').trim().toLowerCase();
                    if (nombre.length === 0) return false;
                    if (nombre.includes(inputText)) return true;
                    // Campo opcional para buscar también por un código (p.ej. ICAO), sin afectar el valor mostrado/seleccionado
                    let codigo = (item['codigo'] || '').trim().toLowerCase();
                    return codigo.length > 0 && codigo.includes(inputText);
                }).slice(0, 6);

                // Vaciar el contenido actual del listUL antes de actualizar
                $(listUL).empty();

                if (filteredDatos.length > 0) {
                    // Crear y agregar nuevas opciones filtradas al listUL
                    filteredDatos.forEach(function (item) {

                        let lista = $('<listado-srch>').val(item.id).text(item.nombre);
                        $(listUL).append(lista);

                        lista.on('mousedown', function (event) {
                            event.preventDefault(); // Prevenir el comportamiento predeterminado
                            // eliminar listas anteriores
                            $(filtroList).empty();

                            // agregar la lista seleccionado
                            listUL.append(lista);

                            resolve(item);
                            limpiarLista();
                        });

                    });
                } else {
                    $(listUL).append('No se encontraron resultados');
                    $(listUL).append(`<svg width="100%" height="120" viewBox="0 0 184 152" xmlns="http://www.w3.org/2000/svg">
                            <title>No hay datos</title>
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(24 31.67)">
                                    <ellipse fill-opacity=".8" fill="#F5F5F7" cx="67.797" cy="106.89" rx="67.797" ry="12.668"></ellipse>
                                    <path d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z" fill="#AEB8C2"></path>
                                    <path d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z" fill="url(#linearGradient-1)" transform="translate(13.56)"></path>
                                    <path d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" fill="#F5F5F7"></path>
                                    <path d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z" fill="#DCE0E6"></path>
                                </g>
                                <path d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z" fill="#DCE0E6"></path>
                                <g transform="translate(149.65 15.383)" fill="#FFF">
                                    <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"></ellipse>
                                    <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"></path>
                                </g>
                            </g>
                        </svg>
                    `);
                }

                // Reiniciar el índice actual después de filtrar
                currentIndex = -1;
                // Actualizar la selección resaltada si es necesario
                actualizarSeleccion();
            }

            function limpiarLista() {
                $(contFiltro).hide();
                $(contFiltro).empty();
                $(listUL).empty();
                $(filtroList).empty();
                currentIndex = -1;
            }

        } catch (error) {
            console.error('Error al obtener y mostrar los datos:', error);
            reject('error')
        }
    });
}
function validarHora(inputElement) {
    const valor = inputElement.value;
    const [hora, minutos] = valor.split(':').map(Number);

    if (isNaN(hora) || isNaN(minutos) || hora > 23 || minutos > 59 || hora < 0 || minutos < 0) {
        inputElement.value = ''; // Limpiar el valor si es inválido
        SwalToast('warning', 'Ingresa una hora válida HH:MM.', 2500);
    }
}
function sumarHoras(hora1, hora2) {
    // Función para convertir una hora en minutos
    function horaAMinutos(hora) {
        const partes = hora.split(':');
        return parseInt(partes[0], 10) * 60 + parseInt(partes[1], 10);
    }

    // Función para convertir minutos a hora en formato HH:mm
    function minutosAHora(minutos) {
        // El operador % 1440 asegura que el resultado sea en un formato de 24 horas (1440 minutos en un día)
        const minutosDelDia = minutos % 1440;
        const horas = Math.floor(minutosDelDia / 60);
        const minutosRestantes = minutosDelDia % 60;
        return `${horas.toString().padStart(2, '0')}:${minutosRestantes.toString().padStart(2, '0')}`;
    }

    // Convertir ambas horas a minutos
    const minutosHora1 = horaAMinutos(hora1);
    const minutosHora2 = horaAMinutos(hora2);

    // Sumar los minutos
    const minutosTotales = minutosHora1 + minutosHora2;

    // Convertir el total de minutos de nuevo a formato HH:mm
    return minutosAHora(minutosTotales);
}
// Establecer Fecha Actual D-M-Y
function setFechaActual(id) {
    let elemento = document.getElementById(id);
    // Crear un nuevo objeto de fecha con la fecha y hora actual
    let fechaActual = new Date();
    let dia = fechaActual.getDate().toString().padStart(2, '0'); // Asegura que el día tenga dos dígitos
    let mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga dos dígitos
    let anio = fechaActual.getFullYear();

    // Formatear la fecha como D-M-Y
    let fechaFormateada = dia + '/' + mes + '/' + anio;

    // Asignar la fecha formateada al elemento
    elemento.value = fechaFormateada;
}
function obtenerFechaActual() {
    let fechaActual = new Date();
    let dia = fechaActual.getDate().toString().padStart(2, '0'); // Asegura que el día tenga dos dígitos
    let mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga dos dígitos
    let anio = fechaActual.getFullYear();

    return anio + '/' + mes + '/' + dia;
}
// Formato de Fecha Dia-Mes
function formatoDiaMes(fecha) {
    // fecha = fecha.replace('/', '-');
    fecha = fecha.replace(/\//g, '-');

    // Dividir la fecha en componentes de año, mes y día
    const [year, month, day] = fecha.split('-').map(Number);

    // Crear un objeto Date utilizando los componentes de la fecha
    const date = new Date(year, month - 1, day); // El mes se ajusta restando 1

    // Opciones para el formateo del mes
    const opcionesMes = { month: 'short' }; // Abreviatura del mes
    const mes = new Intl.DateTimeFormat('es-ES', opcionesMes).format(date).toUpperCase(); // Formatear y convertir a mayúsculas

    // Obtener el día
    const dia = date.getDate();

    // Retornar el formato deseado
    return `${dia} ${mes}`;
}
// Formato Fecha  MIE-20-NOV
function formatoDiaMesCompleto(fecha) {
    // Dividir la fecha en componentes de año, mes y día
    const [year, month, day] = fecha.split('-').map(Number);

    // Crear un objeto Date utilizando los componentes de la fecha
    const date = new Date(year, month - 1, day); // El mes se ajusta restando 1

    // Opciones para el formateo del día, mes y día de la semana
    const opcionesDiaSemana = { weekday: 'short' }; // Abreviatura del día de la semana
    const opcionesMes = { month: 'short' }; // Abreviatura del mes

    // Formatear y convertir a mayúsculas
    const diaSemana = new Intl.DateTimeFormat('es-ES', opcionesDiaSemana).format(date).toUpperCase();
    const mes = new Intl.DateTimeFormat('es-ES', opcionesMes).format(date).toUpperCase();

    // Obtener el día del mes
    const diaMes = date.getDate();

    // Retornar el formato deseado: DIA-#-MES
    return `${diaSemana}-${diaMes}-${mes}`;
}
// Formato de Fecha a Y-M-D
function formatearFecha(fecha) {
    // formato valido => '2024-05-05'
    if (!fecha) return null; // Manejar caso de fecha vacía o nula

    // Convertir a string si no lo es (por ejemplo, si es un objeto Date)
    fecha = fecha.toString();

    // Verificar si la fecha es en formato 'YYYY-MM-DD'
    if (fecha.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Si es 'YYYY-MM-DD', simplemente devolverla en formato 'DD/MM/YYYY'
        const [year, month, day] = fecha.split('-');
        // return `${day}/${month}/${year}`;
        return `${year}/${month}/${day}`;
    }

    // Intentar parsear la fecha
    let parsedDate = new Date(fecha);
    if (!isNaN(parsedDate.getTime())) {
        // Si el parseo fue exitoso, formatear la fecha en 'DD/MM/YYYY'
        let dia = parsedDate.getDate().toString().padStart(2, '0');
        let mes = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Sumamos 1 porque los meses van de 0 a 11
        let año = parsedDate.getFullYear();
        // return `${dia}/${mes}/${año}`;
        // return `${año}-${mes}-${dia}`;
        return `${año}/${mes}/${dia}`;
    }

    // Si no se puede parsear la fecha, devolver null o la fecha original
    return fecha;
}

// Y/M/D
function formatearFechaYear(fecha) {
    // Si la entrada es una cadena de texto, intenta convertirla a un objeto Date
    if (typeof fecha === 'string') {
        // Verifica si la fecha ya está en el formato 'YYYY/MM/DD' o 'YYYY-MM-DD'
        if (/^\d{4}[\/-]\d{1,2}[\/-]\d{1,2}$/.test(fecha)) {
            // Si el separador es '-', reemplazarlo por '/'
            if (fecha.includes('-')) {
                fecha = fecha.replace(/-/g, '/');
            }
            return fecha; // Ya está en el formato correcto
        } else {
            // Si no, intenta parsear la fecha como una fecha estándar de JavaScript
            fecha = new Date(fecha);
        }
    } else if (!(fecha instanceof Date)) {
        return ''
    }

    // Obtener año, mes y día
    const anio = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Meses son 0-indexed
    const dia = fecha.getDate().toString().padStart(2, '0');

    // Retornar la fecha formateada
    return `${anio}/${mes}/${dia}`;
}
// D/M/Y
function formatearFechaCompletaBORRAR(fechaCompleta) {
    // Crear un objeto de fecha
    let fecha = new Date(fechaCompleta);

    // Verificar si la fecha es válida
    if (isNaN(fecha.getTime())) {
        return null; // Devuelve null si la fecha no es válida
    }

    // Obtener los componentes de la fecha
    let dia = fecha.getDate();
    let mes = fecha.getMonth() + 1; // Los meses van de 0 a 11, sumamos 1 para obtener el mes correcto
    let año = fecha.getFullYear();

    // Formatear la fecha en Día/Mes/Año
    return `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${año}`;
}
function convertirAFecha(fechaStr) {
    if (!fechaStr) return null; // Manejar caso de fecha vacía o nula

    // if(fechaStr != Number) return new Date('Y-m-d');
    const partes = fechaStr.split('/');
    const año = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1; // Los meses en JavaScript van de 0 a 11
    const dia = parseInt(partes[2], 10);
    return new Date(año, mes, dia);
}
function formatearFechaCompleta(fechaCompleta) {
    if (!fechaCompleta) return null;

    // Separar fecha y hora (si la hay)
    const [fecha] = fechaCompleta.split(" ");

    // Separar año, mes, día
    const [anio, mes, dia] = fecha.split("-");

    // Retornar formateado sin usar new Date()
    return `${dia}/${mes}/${anio}`;
}
function obtenerDia(fecha) {
    if (!fecha) return null; // Manejar caso de fecha vacía o nula

    // Asumir que la fecha viene en formato 'DD/MM/YYYY'
    const partes = fecha.split('/');

    // Verificar que la fecha tiene 3 partes (día, mes, año)
    if (partes.length === 3) {
        const [año, mes, dia] = partes;
        return dia; // Devolver el día
    }

    return null; // Devolver null si el formato no es válido
}
function formatoFechaMes(fecha) {
    // formato valido => '2024-05-05'
    if (!fecha) return null; // Manejar caso de fecha vacía o nula

    // Convertir a string si no lo es (por ejemplo, si es un objeto Date)
    fecha = fecha.toString();

    // Verificar si la fecha es en formato 'YYYY-MM-DD'
    if (fecha.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Si es 'YYYY-MM-DD', simplemente devolverla en formato 'DD-MMM-YYYY'
        const [year, month, day] = fecha.split('-');
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        return `${day}-${meses[month - 1]}-${year}`;
    }

    // Intentar parsear la fecha
    let parsedDate = new Date(fecha);
    if (!isNaN(parsedDate.getTime())) {
        // Si el parseo fue exitoso, formatear la fecha en 'DD-MMM-YYYY'
        let dia = parsedDate.getDate().toString().padStart(2, '0');
        let mes = parsedDate.getMonth();
        let año = parsedDate.getFullYear();
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        return `${dia}-${meses[mes]}-${año}`;
    }

    return fecha;
    // Formato de salida => '05-May-2024'
}
function calcularDiferenciaDias(fecha1, fecha2) {
    if (!fecha1 || !fecha2) return null
    const fechaInicio = convertirAFecha(fecha1);
    const fechaFin = convertirAFecha(fecha2);


    const diferenciaTiempo = fechaFin.getTime() - fechaInicio.getTime();
    // const diferenciaTiempo = fechaFin - fechaInicio;
    const diferenciaDias = diferenciaTiempo / (1000 * 60 * 60 * 24); // Convertir de milisegundos a días
    return diferenciaDias;
}
function formatearHoraFloat(valor) {
    // Expresión regular para encontrar el patrón de hora
    const patron = /(\d+):(\d+)/;
    const match = valor.match(patron);

    if (match) {
        const horas = parseInt(match[1]);
        const minutos = parseInt(match[2]);
        const totalMinutos = horas * 60 + minutos;
        // Convertir los minutos a un número flotante
        const resultado = totalMinutos / 60.0;
        return resultado.toFixed(2);
    } else {
        return null;
    }
}
// Formato hora con ':'
function formatoHora(hora) {

    let horas = 0;
    let minutos = 0;
    if (hora) {
        if (hora.includes(':')) {
            const partes = hora.split(':');

            horas = partes[0];
            minutos = partes[1];
        } else {
            horas = hora;
        }
    } else {
        horas = hora;
    }
    // Convertir el valor numérico a horas y minutos
    const hrsNum = parseFloat(horas);
    const minNum = parseFloat(minutos);

    const horaFormateada = `${hrsNum.toString().padStart(2, '0')}:${minNum.toString().padStart(2, '0')}`;
    const horaRegex = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;

    if (horaRegex.test(horaFormateada)) {
        return horaFormateada; // Devolver la hora formateada si es válida
    } else {
        return '00:00'; // Devolver un valor por defecto si el formato no es válido
    }
}
function convertirAHorasDecimales(tiempo) {
    // Dividimos el tiempo en horas y minutos
    const [horas, minutos] = tiempo.split(':').map(Number);

    // Convertimos los minutos a su equivalente en horas decimales y sumamos las horas
    const horasDecimales = horas + (minutos / 60);

    return horasDecimales;
}
function normalizarHora(hora) {
    if (!hora) return null;

    hora = hora.toString().trim();

    // Caso: número simple ("7", "09", "13")
    if (/^\d+$/.test(hora)) {
        const h = parseInt(hora, 10);
        if (h < 0 || h > 23) return null;
        return `${h.toString().padStart(2, '0')}:00`;
    }

    // Caso: HH:mm
    if (/^\d{1,2}:\d{1,2}$/.test(hora)) {
        let [h, m] = hora.split(':').map(v => parseInt(v, 10));
        if (h < 0 || h > 23 || m < 0 || m > 59) return null;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    }

    // Caso: decimal ("7.5" → 07:30)
    if (!isNaN(parseFloat(hora))) {
        const num = parseFloat(hora);
        if (num < 0 || num >= 24) return null;
        const h = Math.floor(num);
        const m = Math.round((num - h) * 60);
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    }

    return null;
}
// Hora de llegada de una ruta: hora de salida + tiempo estimado de la aeronave en esa ruta.
// Devuelve '0' cuando la ruta todavia no tiene hora de salida capturada.
function horaLlegadaRuta(ruta) {
    if (!ruta) return '0';

    const horaSalida = normalizarHora(ruta.hora_salida);
    if (!horaSalida || horaSalida === '00:00') return '0';

    const tiempoEstimado = ruta.tiempo_estimado ?? '00:00:00';

    return sumarHoras(horaSalida, tiempoEstimado);
}
function yearValidate(year) {
    // Verifica si es un número
    if (typeof year !== 'number') {
        return false;
    }

    // Verifica si es un entero
    if (!Number.isInteger(year)) {
        return false;
    }

    // Verifica si está dentro de un rango razonable (por ejemplo, entre 1000 y 9999)
    if (year < 1000 || year > 9999) {
        return false;
    }

    // Si pasa todas las validaciones, el año es válido
    return true;
}
function limpiarRuta(id) {
    let form = document.getElementById(id);

    // Obtener todos los elementos select dentro del formulario
    let selects = form.querySelectorAll('select');

    // Iterar sobre cada elemento select
    selects.forEach(function (select) {
        let selectId = select.id;
        // Obtener el primer option del select
        let firstOption = select.querySelector('option');

        if (selectId.includes('origen')) {
            firstOption.text = 'Origen';
        } else if (selectId.includes('destino')) {
            firstOption.text = 'Destino';
        } else {
            console.log('No se reconoce el tipo')
        }
    });
}
async function limpiarFilaGrid(gridApi, rowNode) {

    // Obtén todas las columnas del grid
    const allColumns = [];
    gridApi.forEachNode(node => {
        const rowData = node.data;
        allColumns.push(rowData);
    });

    // Crea un objeto vacío para almacenar los cambios
    let updatedData = {};

    // Itera sobre cada columna y establece el valor a null o ''
    allColumns.forEach(column => {
        const colId = column.colId;
        // updatedData[colId] = null; // o '' si prefieres
    });

    // Actualiza los datos de la fila
    rowNode.setData(updatedData);
}
// Pasar idForm, quitar o poner
async function deshabilitarElemento(...elementoId) {
    elementoId.forEach(id => {
        const elemento = document.getElementById(id);
        elemento.classList.add('disabled-element'); // Agregar clase para deshabilitar estilos
        // elemento.disabled = true;
    });

}
async function habilitarElemento(...elementoId) {
    elementoId.forEach(id => {
        const elemento = document.getElementById(id);
        elemento.classList.remove('disabled-element'); // Agregar clase para deshabilitar estilos
        // elemento.disabled = false;
    });
}
async function dasactivarElementos(...elementoId) {
    elementoId.forEach(id => {
        const elemento = document.getElementById(id);
        if (elemento) { elemento.disabled = true; }
        else { SwalToast('warning', `Error al activar: ${id}.`, 2500); }
    });
}
async function activarElementos(...elementoId) {
    elementoId.forEach(id => {
        const elemento = document.getElementById(id);
        if (elemento) { elemento.disabled = false; }
        else { SwalToast('warning', `Error al activar: ${id}.`, 2500); }
    });
}
function pagina_actual($path) {
    return str_contains($_SERVER['PATH_INFO'], $path) ? true : false;
}
function actualizarPagina(event) {
    event.preventDefault();
    location.reload();
}
function validarDocumento(tipo, valor) {
    const reglas = {
        pasaporte_nacional: {
            longitud: [9, 9],           // longitud exacta de 9 caracteres
            regex: /^[A-Z0-9]{9}$/,      // solo mayúsculas y números
            descripcion: "El número de pasaporte mexicano consta de 9 caracteres alfanuméricos."
        },
        pasaporte_internacional: {
            longitud: [6, 12],
            regex: /^[A-Z0-9]{6,12}$/i,
            descripcion: "El número de pasaporte internacional debe tener entre 6 y 12 caracteres alfanuméricos."
        },
        visa: {
            longitud: [8, 12],
            regex: /^[A-Z0-9]{8,12}$/i,
            descripcion: "El número de visa debe tener entre 8 y 12 caracteres alfanuméricos."
        },
        // ine: {
        //     longitud: [13],
        //     regex: /^[0-9]{13}$/,
        //     descripcion: "El INE debe tener exactamente 13 dígitos numéricos."
        // },
        curp: {
            longitud: [18],
            regex: /^[A-Z][AEIOU][A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]\d$/,
            descripcion: "El CURP debe tener exactamente 18 caracteres con el formato oficial (RFC-like)."
        },
        licencia_conducir: {
            longitud: [8, 10],
            regex: /^[A-Z0-9]{8,10}$/i,
            descripcion: "La licencia debe tener entre 8 y 10 caracteres alfanuméricos."
        },
        cartilla_militar: {
            longitud: [10, 12],
            regex: /^[A-Z0-9]{10,12}$/i,
            descripcion: "La cartilla debe tener entre 10 y 12 caracteres alfanuméricos."
        },
        documento_migratorio: {
            longitud: [11, 13],
            regex: /^[A-Z0-9]{11,13}$/i,
            descripcion: "El documento migratorio debe tener entre 11 y 13 caracteres alfanuméricos."
        }
    };

    const regla = reglas[tipo];
    if (!regla) {
        return { valido: true, mensaje: "Tipo de documento no reconocido o sin validación específica." };
    }

    const valorLimpio = valor.trim().toUpperCase();
    const longitud = valorLimpio.length;
    const min = regla.longitud[0];
    const max = regla.longitud[1] ?? min;

    if (longitud < min || longitud > max) {
        return {
            valido: false,
            mensaje: `Longitud inválida. Debe tener entre ${min} y ${max} caracteres.`
        };
    }

    if (!regla.regex.test(valorLimpio)) {
        return {
            valido: false,
            mensaje: `Formato inválido. ${regla.descripcion}`
        };
    }

    return { valido: true, mensaje: "Documento válido." };
}

// Mostrar / Ocultar
function showDivById(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = 'block';
}
function hideDivById(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
}
const hideSwal = () => Swal.close();


// COMPONENTES PERSONALIZADOS
(function () {
    // Definir y registrar el componente personalizado directamente
    class ListadoComponent extends HTMLElement {
        constructor() {
            super();
        }

        static get observedAttributes() {
            return ['value', 'text'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'value') {
                this._value = newValue;
            }
            if (name === 'text') {
                this._text = newValue;
            }
            this.render();

        }

        render() {
            // Ahora el contenido se coloca directamente en el elemento, sin usar shadow DOM.
            this.innerHTML = `${this._text || ''}`;
        }

        get value() {
            return this._value;
        }

        set value(val) {
            this.setAttribute('value', val);
            // Lanzar evento change al cambiar el valor
            this.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    // Registramos el componente personalizado
    customElements.define('listado-srch', ListadoComponent);
})();